
























































import {Component, Vue, Prop, Watch} from 'vue-property-decorator'
import {Drawer} from 'element-ui'

@Component({
  components: {
    [Drawer.name]: Drawer,
  },
})
/**
 * @displayName BttPopup
 * bottom to top drawer popup
 */
export default class BttPopup extends Vue {
  @Prop({default: false, type: Boolean}) value: boolean
  @Prop({default: 'auto', type: String}) size: string
  @Prop({default: true, type: Boolean}) wrapperClosable: boolean
  @Prop({default: '', type: String}) id: string

  open: boolean = true
  drawerHeight: number = 0

  get drawerSize() {
    if(this.size === 'auto' || this.size === '100%') {
      if(window.innerHeight <= this.drawerHeight) {
        return '90%'
      }
    }
    return this.size
  }

  get uniqueId() {
    if(!this.id) {
      return Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5)
    }
    return this.id
  }

  @Watch('value', {immediate: true})
  __value(value) {
    this.open = value
  }

  onChange(value: boolean) {
    this.open = value
    this.$emit('input', value)
  }

  onOpened() {
    this.$emit('opened')
    this.setPopupSize()
  }

  setPopupSize() {
    const drawerEl: any = document.querySelector(`[id=${this.uniqueId}] .el-drawer.btt`)
    this.drawerHeight = drawerEl?.offsetHeight || 0
    document.body.classList.add('el-popup-parent--hidden')
  }

  resetPopupSize() {
    this.drawerHeight = 0
    document.body.classList.remove('el-popup-parent--hidden')
  }
}
